export default __webpack_public_path__ + "static/media/a037-student-t3-s3-7.44aea7da.svg";